import { motion } from "framer-motion";
import { EXPERIENCE } from "@/constants/testIds";

const TIMELINE = [
  {
    year: "Jan 2024 — Present",
    title: "Finishing Carpenter — Custom Homes",
    place: "Martinwood Finishing Ltd · Calgary, AB",
    notes: [
      "Finishing carpentry on custom residential projects subcontracted through Echo House Finishing.",
      "High-end custom builds for Light House Homes and Baywest Homes.",
      "Installed interior and exterior doors, baseboards, casings, and window trims with clean, accurate finish work.",
      "Read and interpreted blueprints and floor plans to determine layout and installation requirements.",
      "Constructed and installed custom shelving, closet systems, and built-ins.",
      "Collaborated with supervisors and other trades to complete projects safely and efficiently.",
      "Maintained organized, clean work areas to protect finished surfaces and flooring.",
    ],
  },
  {
    year: "Education",
    title: "High School Diploma — STEM Strand",
    place: "Foundation in problem-solving, math, and applied sciences",
    notes: [
      "Valid Class 5 GDL Driver's License.",
      "Pursuing formal carpentry apprenticeship training.",
    ],
  },
];

export const Experience = () => (
  <section id="experience" data-testid={EXPERIENCE.root} className="py-24 md:py-32">
    <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-20">
      <div className="grid grid-cols-1 md:grid-cols-12 mb-16 gap-6">
        <div className="md:col-span-9">
          <p className="eyebrow mb-6">Index</p>
          <h2 className="font-serif text-5xl md:text-7xl leading-[1.02]">
            Experience &amp; <span className="italic text-clay">education.</span>
          </h2>
        </div>
      </div>

      <div className="border-t hairline">
        {TIMELINE.map((entry, i) => (
          <motion.div
            key={i}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.7, delay: i * 0.05 }}
            className="grid grid-cols-1 md:grid-cols-12 gap-6 py-12 border-b hairline hover:bg-bone-dark/40 transition-colors duration-300"
          >
            <div className="md:col-span-3">
              <p className="eyebrow">{entry.year}</p>
            </div>
            <div className="md:col-span-5">
              <h3 className="font-serif text-3xl md:text-4xl leading-tight">
                {entry.title}
              </h3>
              <p className="text-ink/60 mt-2 italic">{entry.place}</p>
            </div>
            <ul className="md:col-span-4 text-ink/70 leading-relaxed space-y-2 text-sm">
              {entry.notes.map((n, idx) => (
                <li key={idx} className="flex gap-3">
                  <span className="text-clay mt-1">—</span>
                  <span>{n}</span>
                </li>
              ))}
            </ul>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
